import { BrowserRouter as Router ,Routes,Route  } from "react-router-dom";
import App from "../App";

import Reg from '../views/index/Reg'


const BaseRouter = () => {
    return(
        <Router>
            <Routes>
               
                <Route path="/reg" element={<Reg/>}></Route>
                <Route path="/" element={<Reg/>}></Route>
                <Route path="*" element={<Reg/>}></Route>
            </Routes>
        </Router>
        
    )
}

export default BaseRouter;